var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_6498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0161 32.4312C20.917 32.5174 20.7953 32.5736 20.6654 32.593C20.5355 32.6125 20.4028 32.5945 20.2827 32.5411C20.1627 32.4878 20.0604 32.4013 19.9878 32.2919C19.9152 32.1824 19.8753 32.0545 19.8729 31.9232V30.3747C19.5067 30.3747 19.1555 30.2292 18.8966 29.9703C18.6377 29.7114 18.4922 29.3602 18.4922 28.994V24.1616C18.4922 23.7954 18.6377 23.4442 18.8966 23.1853C19.1555 22.9264 19.5067 22.7809 19.8729 22.7809H27.4667C27.8329 22.7809 28.184 22.9264 28.443 23.1853C28.7019 23.4442 28.8474 23.7954 28.8474 24.1616V28.994C28.8474 29.3602 28.7019 29.7114 28.443 29.9703C28.184 30.2292 27.8329 30.3747 27.4667 30.3747H24.017L21.0161 32.4312ZM29.5377 26.9347C29.5355 27.0196 29.5355 27.1046 29.5377 27.1895V26.934C29.5412 26.8602 29.5419 25.9351 29.5405 24.1595C29.5399 23.6106 29.3215 23.0844 28.9331 22.6964C28.5448 22.3085 28.0183 22.0906 27.4694 22.0906H21.9439V21.4002C21.9439 21.034 22.0894 20.6829 22.3483 20.4239C22.6072 20.165 22.9584 20.0195 23.3246 20.0195H30.9184C31.2846 20.0195 31.6358 20.165 31.8947 20.4239C32.1536 20.6829 32.2991 21.034 32.2991 21.4002V26.2326C32.2991 26.5988 32.1536 26.95 31.8947 27.2089C31.6358 27.4679 31.2846 27.6133 30.9184 27.6133V29.1618C30.916 29.2931 30.8761 29.421 30.8035 29.5305C30.7309 29.6399 30.6286 29.7264 30.5085 29.7798C30.3885 29.8331 30.2558 29.8511 30.1259 29.8316C29.996 29.8122 29.8743 29.7561 29.7752 29.6699L29.5377 29.5069V26.9347Z",
    fill: "url(#paint0_linear_722_6498)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6498",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6498",
    x1: 24.8787,
    y1: 20.8227,
    x2: 24.2768,
    y2: 31.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#595CE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(18.332 18.6016)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComment);
export default __webpack_public_path__ + "static/media/ico-comment.c4eb62fcd769e672d941c6e280559649.svg";
export { ForwardRef as ReactComponent };